export const PROJECT_VISIBILITY_VALUES = {
  private: 'private',
  public: 'public',
  archived: 'archived',
} as const;

export type ProjectVisibility =
  (typeof PROJECT_VISIBILITY_VALUES)[keyof typeof PROJECT_VISIBILITY_VALUES];

export const PROJECT_VISIBILITY_LABELS: Record<ProjectVisibility, string> = {
  private: 'Private',
  public: 'Public',
  archived: 'Archived',
};
